import React, { useEffect, useState } from 'react';

// 活动报名页面，主流小程序风格
const WxActivity = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/wx/entry';
      return;
    }
    fetch('/api/activities', { headers: { Authorization: `Bearer ${token}` } })
      .then(res => res.json())
      .then(data => setActivities(data)).finally(() => setLoading(false));
  }, []);

  const handleSignup = (id) => {
    const token = localStorage.getItem('token');
    fetch(`/api/activities/${id}/signup`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setMsg(data.message || '报名成功'));
  };

  if (loading) return <div style={{textAlign:'center',marginTop:'30vh'}}>加载中…</div>;

  return (
    <div style={{padding:16,maxWidth:400,margin:'0 auto',fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI'}}>
      <h2 style={{textAlign:'center'}}>活动报名</h2>
      {msg && <div style={{color:'green',marginBottom:8}}>{msg}</div>}
      <ul style={{listStyle:'none',padding:0}}>
        {activities.length === 0 && <li>暂无可报名活动</li>}
        {activities.map(a => (
          <li key={a.id} style={{borderBottom:'1px solid #eee',padding:'12px 0'}}>
            <div style={{fontWeight:'bold'}}>{a.name}</div>
            <div style={{fontSize:13,color:'#888'}}>{a.description}</div>
            <button style={{marginTop:6,padding:'6px 16px',border:'none',borderRadius:4,background:'#07c160',color:'#fff'}} onClick={()=>handleSignup(a.id)}>报名</button>
            <button style={{marginLeft:8,padding:'6px 10px',border:'none',borderRadius:4,background:'#f5f5f5',color:'#333'}} onClick={()=>window.location.href=`/wx/activity/${a.id}`}>详情</button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WxActivity;
